import type { ComponentType } from 'react';

import clsx from 'clsx';

interface CommonTitleProps {
  title: string;
  Icon: ComponentType<{ className?: string }>;
  className?: string;
}

export function CommonTitle({ className, title, Icon }: CommonTitleProps) {
  return (
    <h2
      className={clsx(
        `mr-auto flex items-center gap-3 text-xl font-bold text-gray-600
        dark:text-gray-200`,
        className
      )}
    >
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-blue-700">
        <Icon className="h-5 w-5 text-gray-100" />
      </span>
      {title}
    </h2>
  );
}
